import { useCallback } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "./LiveOnlineClasses.css";

const LiveOnlineClasses = () => {
  const navigate = useNavigate();

  const onLogo1ContainerClick = useCallback(() => {
    navigate("/");
  }, [navigate]);

  const onHomeContainerClick = useCallback(() => {
    navigate("/");
  }, [navigate]);

  const onAboutContainerClick = useCallback(() => {
    navigate("/aboutus");
  }, [navigate]);

  const onOurProductsTextClick = useCallback(() => {
    navigate("/our-products");
  }, [navigate]);

  const onButtonDesktopSecondaryClick = useCallback(() => {
    navigate("/login");
  }, [navigate]);

  const onButtonDesktopPrimaryClick = useCallback(() => {
    navigate("/step1");
  }, [navigate]);

  const onButtonDesktopPrimary1Click = useCallback(() => {
    navigate("/class");
  }, [navigate]);

  const onButtonDesktopPrimary2Click = useCallback(() => {
    navigate("/class");
  }, [navigate]);

  const onButtonDesktopPrimary3Click = useCallback(() => {
    navigate("/class");
  }, [navigate]);

  const onButtonDesktopPrimary4Click = useCallback(() => {
    navigate("/class");
  }, [navigate]);

  const onButtonDesktopPrimary5Click = useCallback(() => {
    navigate("/class");
  }, [navigate]);

  const onButtonDesktopPrimary6Click = useCallback(() => {
    navigate("/class");
  }, [navigate]);

  const onButtonDesktopPrimary7Click = useCallback(() => {
    navigate("/class");
  }, [navigate]);

  const onButtonDesktopPrimary8Click = useCallback(() => {
    navigate("/class");
  }, [navigate]);

  const onButtonDesktopPrimary9Click = useCallback(() => {
    navigate("/class");
  }, [navigate]);

  return (
    <div className="live-online-classes6">
      <div className="nav-div3">
        <div className="logo1-div11" onClick={onLogo1ContainerClick}>
          <img className="vector-icon290" alt="" src="../vector.svg" />
          <img className="vector-icon291" alt="" src="../vector266.svg" />
          <img className="vector-icon292" alt="" src="../vector2.svg" />
          <img className="vector-icon293" alt="" src="../vector268.svg" />
          <img className="vector-icon294" alt="" src="../vector294.svg" />
          <img className="vector-icon295" alt="" src="../vector270.svg" />
          <img className="vector-icon296" alt="" src="../vector271.svg" />
          <img className="vector-icon297" alt="" src="../vector272.svg" />
          <img className="vector-icon298" alt="" src="../vector8.svg" />
          <img className="vector-icon299" alt="" src="../vector274.svg" />
          <img className="vector-icon300" alt="" src="../vector275.svg" />
          <img className="vector-icon301" alt="" src="../vector276.svg" />
          <img className="vector-icon302" alt="" src="../vector277.svg" />
          <img className="vector-icon303" alt="" src="../vector278.svg" />
          <img className="vector-icon304" alt="" src="../vector279.svg" />
          <img className="vector-icon305" alt="" src="../vector280.svg" />
          <img className="vector-icon306" alt="" src="../vector16.svg" />
          <img className="vector-icon307" alt="" src="../vector17.svg" />
          <img className="vector-icon308" alt="" src="../vector283.svg" />
          <img className="vector-icon309" alt="" src="../vector284.svg" />
          <img className="vector-icon310" alt="" src="../vector285.svg" />
          <img className="vector-icon311" alt="" src="../vector261.svg" />
          <img className="vector-icon312" alt="" src="../vector22.svg" />
          <img className="vector-icon313" alt="" src="../vector288.svg" />
          <img className="vector-icon314" alt="" src="../vector264.svg" />
          <b className="shuleeazy-b13">ShuleEazy</b>
        </div>
        <div className="frame-div124">
          <div className="frame-div125">
            <div className="home-div2" onClick={onHomeContainerClick}>
              <b className="filter-by">Home</b>
            </div>
            <div className="home-div2" onClick={onAboutContainerClick}>
              <b className="filter-by">About Us</b>
            </div>
            <div className="products-div4">
              <div className="frame-div126">
                <b className="our-products-b3" onClick={onOurProductsTextClick}>
                  Our Products
                </b>
                <img
                  className="outline-24px-chevron-down3"
                  alt=""
                  src="../outline-24px--chevrondown1.svg"
                />
              </div>
            </div>
            <div className="contact-div3">
              <b className="filter-by">Contact Us</b>
            </div>
          </div>
          <div className="frame-div127">
            <button
              className="buttondesktopsecondary5"
              onClick={onButtonDesktopSecondaryClick}
            >
              <b className="save-and-next28">log in</b>
            </button>
            <button
              className="buttondesktopprimary18"
              onClick={onButtonDesktopPrimaryClick}
            >
              <b className="save-and-next29">sign up</b>
            </button>
          </div>
        </div>
      </div>
      <div className="body-div1">
        <div className="hero-div1">
          <img
            className="hero-image-icon1"
            alt=""
            src="../hero-image1@2x.png"
          />
          <div className="hero-text-div1">
            <b className="hands-on-and-fun-way-for-kids">
              Hands-on and fun way for kids to learn in our live online classes
            </b>
            <b className="our-classes-are-taught-by-the">
              our classes are taught by the best teachers in the country and we
              focus on the 7 core competencies in CBC:
            </b>
            <div className="frame-div128">
              <div className="frame-div126">
                <img
                  className="charmtick-icon4"
                  alt=""
                  src="../charmtick4.svg"
                />
                <div className="communication-and-collaboratio">
                  communication and collaboration
                </div>
              </div>
              <div className="frame-div126">
                <img
                  className="charmtick-icon4"
                  alt=""
                  src="../charmtick4.svg"
                />
                <div className="communication-and-collaboratio">{`critical thinking and problem solving `}</div>
              </div>
              <div className="frame-div126">
                <img
                  className="charmtick-icon4"
                  alt=""
                  src="../charmtick4.svg"
                />
                <div className="communication-and-collaboratio">
                  imagination and creativity
                </div>
              </div>
              <div className="frame-div126">
                <img
                  className="charmtick-icon4"
                  alt=""
                  src="../charmtick4.svg"
                />
                <div className="communication-and-collaboratio">
                  citizenship
                </div>
              </div>
              <div className="frame-div126">
                <img
                  className="charmtick-icon4"
                  alt=""
                  src="../charmtick4.svg"
                />
                <div className="communication-and-collaboratio">
                  self-efficacy
                </div>
              </div>
              <div className="frame-div126">
                <img
                  className="charmtick-icon4"
                  alt=""
                  src="../charmtick4.svg"
                />
                <div className="communication-and-collaboratio">
                  digital literacy
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="frame-div135">
        <div className="classes-we-offre">
          <b className="classes-that-we-offer">Classes that we offer</b>
          <div className="line-div7" />
        </div>
        <div className="filter-div">
          <b className="filter-by">{`Filter By: `}</b>
          <div className="frame-div136">
            <div className="input-with-label-default5">
              <Form.Select className="input-without-label-defaul">
                <option value="Grade1">Grade1</option>
                <option value="Grade2">Grade2</option>
                <option value="Grade3">Grade3</option>
                <option value="Grade4">Grade4</option>
                <option value="Grade5">Grade5</option>
                <option value="Grade6">Grade6</option>
              </Form.Select>
              <div className="label-div">
                <img
                  className="interface-icon-award"
                  alt=""
                  src="../interfaceicon--award.svg"
                />
                <div className="classes-that-we-offer">Classes</div>
                <img
                  className="interface-icon-award"
                  alt=""
                  src="../interfaceicon--award.svg"
                />
              </div>
            </div>
            <div className="input-with-label-default5">
              <Form.Select className="input-without-label-defaul">
                <option value="Mathematics">Mathematics</option>
                <option value="English">English</option>
                <option value="Kiswahili">Kiswahili</option>
                <option value="Science">Science</option>
                <option value="CRE">CRE</option>
                <option value="Social Studies">Social Studies</option>
                <option value="Music">Music</option>
                <option value="French">French</option>
                <option value="Coding">Coding</option>
              </Form.Select>
              <div className="label-div">
                <img
                  className="interface-icon-award"
                  alt=""
                  src="../interfaceicon--award2.svg"
                />
                <div className="classes-that-we-offer">Subjects</div>
                <img
                  className="interface-icon-award"
                  alt=""
                  src="../interfaceicon--award2.svg"
                />
              </div>
            </div>
            <div className="input-with-label-default5">
              <Form.Select className="input-without-label-defaul">
                <option value="Joy Queen">Joy Queen</option>
                <option value="Luke Kibiku">Luke Kibiku</option>
                <option value="Daisy Kirui">Daisy Kirui</option>
                <option value="Pius Kimathi">Pius Kimathi</option>
                <option value="Peris Wambui">Peris Wambui</option>
                <option value="Cephas Mutua">Cephas Mutua</option>
              </Form.Select>
              <div className="label-div">
                <img
                  className="interface-icon-award"
                  alt=""
                  src="../interfaceicon--award2.svg"
                />
                <div className="classes-that-we-offer">Teachers</div>
                <img
                  className="interface-icon-award"
                  alt=""
                  src="../interfaceicon--award2.svg"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="classes-div2">
        <div className="frame-div137">
          <div className="frame-div138">
            <div className="frame-div139">
              <img className="frame-icon2" alt="" src="../frame-11812@2x.png" />
              <div className="frame-div140">
                <b className="filter-by">Mathematics</b>
                <div className="rating-stars-div1">
                  <img className="star-icon5" alt="" src="../star-11.svg" />
                  <img className="star-icon5" alt="" src="../star-21.svg" />
                  <img className="star-icon5" alt="" src="../star-31.svg" />
                  <img className="star-icon5" alt="" src="../star-41.svg" />
                  <img className="star-icon5" alt="" src="../star-51.svg" />
                </div>
                <div className="frame-div141">
                  <div className="classes-div3">
                    <img
                      className="game-iconsages"
                      alt=""
                      src="../fluenthatgraduation24regular1.svg"
                    />
                    <div className="grade-1-div">2 Classes</div>
                  </div>
                  <div className="classes-div3">
                    <img
                      className="game-iconsages"
                      alt=""
                      src="../akariconsbook1.svg"
                    />
                    <div className="grade-1-div">14 Lessons</div>
                  </div>
                  <div className="classes-div3">
                    <img
                      className="game-iconsages"
                      alt=""
                      src="../biperson1.svg"
                    />
                    <div className="grade-1-div">12 Learners</div>
                  </div>
                </div>
              </div>
              <div className="this-lesson-is-to-help-learner1">
                This lesson is to help learners understand basic maths concepts
                such as addition, subtraction, multiplication and diviision
              </div>
              <div className="frame-div142">
                <img
                  className="ellipse-icon"
                  alt=""
                  src="../ellipse-3@2x.png"
                />
                <b className="joy-queen-b">Joy Queen</b>
              </div>
              <div className="frame-div143">
                <div className="frame-div140">
                  <div className="classes-div3">
                    <img
                      className="game-iconsages"
                      alt=""
                      src="../akariconsbook2.svg"
                    />
                    <div className="grade-1-div">14 Lessons</div>
                  </div>
                  <div className="classes-div3">
                    <img
                      className="game-iconsages"
                      alt=""
                      src="../biperson2.svg"
                    />
                    <div className="grade-1-div">Max: 15 Learners</div>
                  </div>
                </div>
                <div className="frame-div140">
                  <div className="grade-div">
                    <img
                      className="game-iconsages"
                      alt=""
                      src="../gameiconsages.svg"
                    />
                    <div className="grade-1-div">Grade 1</div>
                  </div>
                  <div className="price-div1">
                    <img
                      className="game-iconsages"
                      alt=""
                      src="../akariconsmoney1.svg"
                    />
                    <div className="grade-1-div">{`Ksh 5,000 `}</div>
                  </div>
                </div>
              </div>
              <button
                className="buttondesktopprimary19"
                onClick={onButtonDesktopPrimary1Click}
              >
                <b className="save-and-next30">get more details</b>
              </button>
            </div>
          </div>
          <div className="frame-div138">
            <div className="frame-div139">
              <img
                className="frame-icon2"
                alt=""
                src="../frame-118121@2x.png"
              />
              <div className="frame-div140">
                <b className="filter-by">Mathematics</b>
                <div className="rating-stars-div1">
                  <img className="star-icon5" alt="" src="../star-12.svg" />
                  <img className="star-icon5" alt="" src="../star-22.svg" />
                  <img className="star-icon5" alt="" src="../star-32.svg" />
                  <img className="star-icon5" alt="" src="../star-42.svg" />
                  <img className="star-icon5" alt="" src="../star-52.svg" />
                </div>
                <div className="frame-div141">
                  <div className="classes-div3">
                    <img
                      className="game-iconsages"
                      alt=""
                      src="../fluenthatgraduation24regular2.svg"
                    />
                    <div className="grade-1-div">2 Classes</div>
                  </div>
                  <div className="classes-div3">
                    <img
                      className="game-iconsages"
                      alt=""
                      src="../akariconsbook3.svg"
                    />
                    <div className="grade-1-div">14 Lessons</div>
                  </div>
                  <div className="classes-div3">
                    <img
                      className="game-iconsages"
                      alt=""
                      src="../biperson3.svg"
                    />
                    <div className="grade-1-div">12 Learners</div>
                  </div>
                </div>
              </div>
              <div className="this-lesson-is-to-help-learner1">
                This lesson is to help learners understand basic maths concepts
                such as addition, subtraction, multiplication and diviision
              </div>
              <div className="frame-div142">
                <img
                  className="ellipse-icon"
                  alt=""
                  src="../ellipse-31@2x.png"
                />
                <b className="joy-queen-b">Joy Queen</b>
              </div>
              <div className="frame-div143">
                <div className="frame-div140">
                  <div className="classes-div3">
                    <img
                      className="game-iconsages"
                      alt=""
                      src="../akariconsbook4.svg"
                    />
                    <div className="grade-1-div">14 Lessons</div>
                  </div>
                  <div className="classes-div3">
                    <img
                      className="game-iconsages"
                      alt=""
                      src="../biperson4.svg"
                    />
                    <div className="grade-1-div">Max: 15 Learners</div>
                  </div>
                </div>
                <div className="frame-div140">
                  <div className="grade-div">
                    <img
                      className="game-iconsages"
                      alt=""
                      src="../gameiconsages1.svg"
                    />
                    <div className="grade-1-div">Grade 1</div>
                  </div>
                  <div className="price-div1">
                    <img
                      className="game-iconsages"
                      alt=""
                      src="../akariconsmoney2.svg"
                    />
                    <div className="grade-1-div">{`Ksh 5,000 `}</div>
                  </div>
                </div>
              </div>
              <button
                className="buttondesktopprimary19"
                onClick={onButtonDesktopPrimary2Click}
              >
                <b className="save-and-next30">get more details</b>
              </button>
            </div>
          </div>
          <div className="frame-div138">
            <div className="frame-div139">
              <img
                className="frame-icon2"
                alt=""
                src="../frame-118122@2x.png"
              />
              <div className="frame-div140">
                <b className="filter-by">Mathematics</b>
                <div className="rating-stars-div1">
                  <img className="star-icon5" alt="" src="../star-13.svg" />
                  <img className="star-icon5" alt="" src="../star-23.svg" />
                  <img className="star-icon5" alt="" src="../star-33.svg" />
                  <img className="star-icon5" alt="" src="../star-43.svg" />
                  <img className="star-icon5" alt="" src="../star-53.svg" />
                </div>
                <div className="frame-div141">
                  <div className="classes-div3">
                    <img
                      className="game-iconsages"
                      alt=""
                      src="../fluenthatgraduation24regular3.svg"
                    />
                    <div className="grade-1-div">2 Classes</div>
                  </div>
                  <div className="classes-div3">
                    <img
                      className="game-iconsages"
                      alt=""
                      src="../akariconsbook5.svg"
                    />
                    <div className="grade-1-div">14 Lessons</div>
                  </div>
                  <div className="classes-div3">
                    <img
                      className="game-iconsages"
                      alt=""
                      src="../biperson5.svg"
                    />
                    <div className="grade-1-div">12 Learners</div>
                  </div>
                </div>
              </div>
              <div className="this-lesson-is-to-help-learner1">
                This lesson is to help learners understand basic maths concepts
                such as addition, subtraction, multiplication and diviision
              </div>
              <div className="frame-div142">
                <img
                  className="ellipse-icon"
                  alt=""
                  src="../ellipse-32@2x.png"
                />
                <b className="joy-queen-b">Joy Queen</b>
              </div>
              <div className="frame-div143">
                <div className="frame-div140">
                  <div className="classes-div3">
                    <img
                      className="game-iconsages"
                      alt=""
                      src="../akariconsbook6.svg"
                    />
                    <div className="grade-1-div">14 Lessons</div>
                  </div>
                  <div className="classes-div3">
                    <img
                      className="game-iconsages"
                      alt=""
                      src="../biperson6.svg"
                    />
                    <div className="grade-1-div">Max: 15 Learners</div>
                  </div>
                </div>
                <div className="frame-div140">
                  <div className="grade-div">
                    <img
                      className="game-iconsages"
                      alt=""
                      src="../gameiconsages2.svg"
                    />
                    <div className="grade-1-div">Grade 1</div>
                  </div>
                  <div className="price-div1">
                    <img
                      className="game-iconsages"
                      alt=""
                      src="../akariconsmoney3.svg"
                    />
                    <div className="grade-1-div">{`Ksh 5,000 `}</div>
                  </div>
                </div>
              </div>
              <button
                className="buttondesktopprimary19"
                onClick={onButtonDesktopPrimary3Click}
              >
                <b className="save-and-next30">get more details</b>
              </button>
            </div>
          </div>
        </div>
        <div className="frame-div137">
          <div className="frame-div138">
            <div className="frame-div139">
              <img
                className="frame-icon5"
                alt=""
                src="../frame-118123@2x.png"
              />
              <div className="frame-div140">
                <b className="filter-by">Mathematics</b>
                <div className="rating-stars-div1">
                  <img className="star-icon5" alt="" src="../star-14.svg" />
                  <img className="star-icon5" alt="" src="../star-24.svg" />
                  <img className="star-icon5" alt="" src="../star-34.svg" />
                  <img className="star-icon5" alt="" src="../star-44.svg" />
                  <img className="star-icon5" alt="" src="../star-54.svg" />
                </div>
                <div className="frame-div141">
                  <div className="classes-div3">
                    <img
                      className="game-iconsages"
                      alt=""
                      src="../fluenthatgraduation24regular4.svg"
                    />
                    <div className="grade-1-div">2 Classes</div>
                  </div>
                  <div className="classes-div3">
                    <img
                      className="game-iconsages"
                      alt=""
                      src="../akariconsbook7.svg"
                    />
                    <div className="grade-1-div">14 Lessons</div>
                  </div>
                  <div className="classes-div3">
                    <img
                      className="game-iconsages"
                      alt=""
                      src="../biperson7.svg"
                    />
                    <div className="grade-1-div">12 Learners</div>
                  </div>
                </div>
              </div>
              <div className="this-lesson-is-to-help-learner1">
                This lesson is to help learners understand basic maths concepts
                such as addition, subtraction, multiplication and diviision
              </div>
              <div className="frame-div142">
                <img
                  className="ellipse-icon"
                  alt=""
                  src="../ellipse-33@2x.png"
                />
                <b className="joy-queen-b">Joy Queen</b>
              </div>
              <div className="frame-div143">
                <div className="frame-div140">
                  <div className="classes-div3">
                    <img
                      className="game-iconsages"
                      alt=""
                      src="../akariconsbook8.svg"
                    />
                    <div className="grade-1-div">14 Lessons</div>
                  </div>
                  <div className="classes-div3">
                    <img
                      className="game-iconsages"
                      alt=""
                      src="../biperson8.svg"
                    />
                    <div className="grade-1-div">Max: 15 Learners</div>
                  </div>
                </div>
                <div className="frame-div140">
                  <div className="grade-div">
                    <img
                      className="game-iconsages"
                      alt=""
                      src="../gameiconsages3.svg"
                    />
                    <div className="grade-1-div">Grade 1</div>
                  </div>
                  <div className="price-div1">
                    <img
                      className="game-iconsages"
                      alt=""
                      src="../akariconsmoney4.svg"
                    />
                    <div className="grade-1-div">{`Ksh 5,000 `}</div>
                  </div>
                </div>
              </div>
              <button
                className="buttondesktopprimary19"
                onClick={onButtonDesktopPrimary4Click}
              >
                <b className="save-and-next30">get more details</b>
              </button>
            </div>
          </div>
          <div className="frame-div138">
            <div className="frame-div139">
              <img
                className="frame-icon5"
                alt=""
                src="../frame-118124@2x.png"
              />
              <div className="frame-div140">
                <b className="filter-by">Mathematics</b>
                <div className="rating-stars-div1">
                  <img className="star-icon5" alt="" src="../star-15.svg" />
                  <img className="star-icon5" alt="" src="../star-25.svg" />
                  <img className="star-icon5" alt="" src="../star-35.svg" />
                  <img className="star-icon5" alt="" src="../star-45.svg" />
                  <img className="star-icon5" alt="" src="../star-55.svg" />
                </div>
                <div className="frame-div141">
                  <div className="classes-div3">
                    <img
                      className="game-iconsages"
                      alt=""
                      src="../fluenthatgraduation24regular5.svg"
                    />
                    <div className="grade-1-div">2 Classes</div>
                  </div>
                  <div className="classes-div3">
                    <img
                      className="game-iconsages"
                      alt=""
                      src="../akariconsbook9.svg"
                    />
                    <div className="grade-1-div">14 Lessons</div>
                  </div>
                  <div className="classes-div3">
                    <img
                      className="game-iconsages"
                      alt=""
                      src="../biperson9.svg"
                    />
                    <div className="grade-1-div">12 Learners</div>
                  </div>
                </div>
              </div>
              <div className="this-lesson-is-to-help-learner1">
                This lesson is to help learners understand basic maths concepts
                such as addition, subtraction, multiplication and diviision
              </div>
              <div className="frame-div142">
                <img
                  className="ellipse-icon"
                  alt=""
                  src="../ellipse-34@2x.png"
                />
                <b className="joy-queen-b">Joy Queen</b>
              </div>
              <div className="frame-div143">
                <div className="frame-div140">
                  <div className="classes-div3">
                    <img
                      className="game-iconsages"
                      alt=""
                      src="../akariconsbook10.svg"
                    />
                    <div className="grade-1-div">14 Lessons</div>
                  </div>
                  <div className="classes-div3">
                    <img
                      className="game-iconsages"
                      alt=""
                      src="../biperson10.svg"
                    />
                    <div className="grade-1-div">Max: 15 Learners</div>
                  </div>
                </div>
                <div className="frame-div140">
                  <div className="grade-div">
                    <img
                      className="game-iconsages"
                      alt=""
                      src="../gameiconsages4.svg"
                    />
                    <div className="grade-1-div">Grade 1</div>
                  </div>
                  <div className="price-div1">
                    <img
                      className="game-iconsages"
                      alt=""
                      src="../akariconsmoney5.svg"
                    />
                    <div className="grade-1-div">{`Ksh 5,000 `}</div>
                  </div>
                </div>
              </div>
              <button
                className="buttondesktopprimary19"
                onClick={onButtonDesktopPrimary5Click}
              >
                <b className="save-and-next30">get more details</b>
              </button>
            </div>
          </div>
          <div className="frame-div138">
            <div className="frame-div139">
              <img
                className="frame-icon5"
                alt=""
                src="../frame-118125@2x.png"
              />
              <div className="frame-div140">
                <b className="filter-by">Mathematics</b>
                <div className="rating-stars-div1">
                  <img className="star-icon5" alt="" src="../star-16.svg" />
                  <img className="star-icon5" alt="" src="../star-26.svg" />
                  <img className="star-icon5" alt="" src="../star-36.svg" />
                  <img className="star-icon5" alt="" src="../star-46.svg" />
                  <img className="star-icon5" alt="" src="../star-56.svg" />
                </div>
                <div className="frame-div141">
                  <div className="classes-div3">
                    <img
                      className="game-iconsages"
                      alt=""
                      src="../fluenthatgraduation24regular6.svg"
                    />
                    <div className="grade-1-div">2 Classes</div>
                  </div>
                  <div className="classes-div3">
                    <img
                      className="game-iconsages"
                      alt=""
                      src="../akariconsbook11.svg"
                    />
                    <div className="grade-1-div">14 Lessons</div>
                  </div>
                  <div className="classes-div3">
                    <img
                      className="game-iconsages"
                      alt=""
                      src="../biperson11.svg"
                    />
                    <div className="grade-1-div">12 Learners</div>
                  </div>
                </div>
              </div>
              <div className="this-lesson-is-to-help-learner1">
                This lesson is to help learners understand basic maths concepts
                such as addition, subtraction, multiplication and diviision
              </div>
              <div className="frame-div142">
                <img
                  className="ellipse-icon"
                  alt=""
                  src="../ellipse-35@2x.png"
                />
                <b className="joy-queen-b">Joy Queen</b>
              </div>
              <div className="frame-div143">
                <div className="frame-div140">
                  <div className="classes-div3">
                    <img
                      className="game-iconsages"
                      alt=""
                      src="../akariconsbook12.svg"
                    />
                    <div className="grade-1-div">14 Lessons</div>
                  </div>
                  <div className="classes-div3">
                    <img
                      className="game-iconsages"
                      alt=""
                      src="../biperson12.svg"
                    />
                    <div className="grade-1-div">Max: 15 Learners</div>
                  </div>
                </div>
                <div className="frame-div140">
                  <div className="grade-div">
                    <img
                      className="game-iconsages"
                      alt=""
                      src="../gameiconsages5.svg"
                    />
                    <div className="grade-1-div">Grade 1</div>
                  </div>
                  <div className="price-div1">
                    <img
                      className="game-iconsages"
                      alt=""
                      src="../akariconsmoney6.svg"
                    />
                    <div className="grade-1-div">{`Ksh 5,000 `}</div>
                  </div>
                </div>
              </div>
              <button
                className="buttondesktopprimary19"
                onClick={onButtonDesktopPrimary6Click}
              >
                <b className="save-and-next30">get more details</b>
              </button>
            </div>
          </div>
        </div>
        <div className="frame-div137">
          <div className="frame-div138">
            <div className="frame-div139">
              <img
                className="frame-icon2"
                alt=""
                src="../frame-118126@2x.png"
              />
              <div className="frame-div140">
                <b className="filter-by">Mathematics</b>
                <div className="rating-stars-div1">
                  <img className="star-icon5" alt="" src="../star-17.svg" />
                  <img className="star-icon5" alt="" src="../star-27.svg" />
                  <img className="star-icon5" alt="" src="../star-37.svg" />
                  <img className="star-icon5" alt="" src="../star-47.svg" />
                  <img className="star-icon5" alt="" src="../star-57.svg" />
                </div>
                <div className="frame-div141">
                  <div className="classes-div3">
                    <img
                      className="game-iconsages"
                      alt=""
                      src="../fluenthatgraduation24regular7.svg"
                    />
                    <div className="grade-1-div">2 Classes</div>
                  </div>
                  <div className="classes-div3">
                    <img
                      className="game-iconsages"
                      alt=""
                      src="../akariconsbook13.svg"
                    />
                    <div className="grade-1-div">14 Lessons</div>
                  </div>
                  <div className="classes-div3">
                    <img
                      className="game-iconsages"
                      alt=""
                      src="../biperson13.svg"
                    />
                    <div className="grade-1-div">12 Learners</div>
                  </div>
                </div>
              </div>
              <div className="this-lesson-is-to-help-learner1">
                This lesson is to help learners understand basic maths concepts
                such as addition, subtraction, multiplication and diviision
              </div>
              <div className="frame-div142">
                <img
                  className="ellipse-icon"
                  alt=""
                  src="../ellipse-36@2x.png"
                />
                <b className="joy-queen-b">Joy Queen</b>
              </div>
              <div className="frame-div143">
                <div className="frame-div140">
                  <div className="classes-div3">
                    <img
                      className="game-iconsages"
                      alt=""
                      src="../akariconsbook14.svg"
                    />
                    <div className="grade-1-div">14 Lessons</div>
                  </div>
                  <div className="classes-div3">
                    <img
                      className="game-iconsages"
                      alt=""
                      src="../biperson14.svg"
                    />
                    <div className="grade-1-div">Max: 15 Learners</div>
                  </div>
                </div>
                <div className="frame-div140">
                  <div className="grade-div">
                    <img
                      className="game-iconsages"
                      alt=""
                      src="../gameiconsages6.svg"
                    />
                    <div className="grade-1-div">Grade 1</div>
                  </div>
                  <div className="price-div1">
                    <img
                      className="game-iconsages"
                      alt=""
                      src="../akariconsmoney7.svg"
                    />
                    <div className="grade-1-div">{`Ksh 5,000 `}</div>
                  </div>
                </div>
              </div>
              <button
                className="buttondesktopprimary19"
                onClick={onButtonDesktopPrimary7Click}
              >
                <b className="save-and-next30">get more details</b>
              </button>
            </div>
          </div>
          <div className="frame-div138">
            <div className="frame-div139">
              <img
                className="frame-icon2"
                alt=""
                src="../frame-118127@2x.png"
              />
              <div className="frame-div140">
                <b className="filter-by">Mathematics</b>
                <div className="rating-stars-div1">
                  <img className="star-icon5" alt="" src="../star-18.svg" />
                  <img className="star-icon5" alt="" src="../star-28.svg" />
                  <img className="star-icon5" alt="" src="../star-38.svg" />
                  <img className="star-icon5" alt="" src="../star-48.svg" />
                  <img className="star-icon5" alt="" src="../star-58.svg" />
                </div>
                <div className="frame-div141">
                  <div className="classes-div3">
                    <img
                      className="game-iconsages"
                      alt=""
                      src="../fluenthatgraduation24regular8.svg"
                    />
                    <div className="grade-1-div">2 Classes</div>
                  </div>
                  <div className="classes-div3">
                    <img
                      className="game-iconsages"
                      alt=""
                      src="../akariconsbook15.svg"
                    />
                    <div className="grade-1-div">14 Lessons</div>
                  </div>
                  <div className="classes-div3">
                    <img
                      className="game-iconsages"
                      alt=""
                      src="../biperson15.svg"
                    />
                    <div className="grade-1-div">12 Learners</div>
                  </div>
                </div>
              </div>
              <div className="this-lesson-is-to-help-learner1">
                This lesson is to help learners understand basic maths concepts
                such as addition, subtraction, multiplication and diviision
              </div>
              <div className="frame-div142">
                <img
                  className="ellipse-icon"
                  alt=""
                  src="../ellipse-37@2x.png"
                />
                <b className="joy-queen-b">Joy Queen</b>
              </div>
              <div className="frame-div143">
                <div className="frame-div140">
                  <div className="classes-div3">
                    <img
                      className="game-iconsages"
                      alt=""
                      src="../akariconsbook16.svg"
                    />
                    <div className="grade-1-div">14 Lessons</div>
                  </div>
                  <div className="classes-div3">
                    <img
                      className="game-iconsages"
                      alt=""
                      src="../biperson16.svg"
                    />
                    <div className="grade-1-div">Max: 15 Learners</div>
                  </div>
                </div>
                <div className="frame-div140">
                  <div className="grade-div">
                    <img
                      className="game-iconsages"
                      alt=""
                      src="../gameiconsages7.svg"
                    />
                    <div className="grade-1-div">Grade 1</div>
                  </div>
                  <div className="price-div1">
                    <img
                      className="game-iconsages"
                      alt=""
                      src="../akariconsmoney8.svg"
                    />
                    <div className="grade-1-div">{`Ksh 5,000 `}</div>
                  </div>
                </div>
              </div>
              <button
                className="buttondesktopprimary19"
                onClick={onButtonDesktopPrimary8Click}
              >
                <b className="save-and-next30">get more details</b>
              </button>
            </div>
          </div>
          <div className="frame-div138">
            <div className="frame-div139">
              <img
                className="frame-icon2"
                alt=""
                src="../frame-118128@2x.png"
              />
              <div className="frame-div140">
                <b className="filter-by">Mathematics</b>
                <div className="rating-stars-div1">
                  <img className="star-icon5" alt="" src="../star-19.svg" />
                  <img className="star-icon5" alt="" src="../star-29.svg" />
                  <img className="star-icon5" alt="" src="../star-39.svg" />
                  <img className="star-icon5" alt="" src="../star-49.svg" />
                  <img className="star-icon5" alt="" src="../star-59.svg" />
                </div>
                <div className="frame-div141">
                  <div className="classes-div3">
                    <img
                      className="game-iconsages"
                      alt=""
                      src="../fluenthatgraduation24regular9.svg"
                    />
                    <div className="grade-1-div">2 Classes</div>
                  </div>
                  <div className="classes-div3">
                    <img
                      className="game-iconsages"
                      alt=""
                      src="../akariconsbook17.svg"
                    />
                    <div className="grade-1-div">14 Lessons</div>
                  </div>
                  <div className="classes-div3">
                    <img
                      className="game-iconsages"
                      alt=""
                      src="../biperson17.svg"
                    />
                    <div className="grade-1-div">12 Learners</div>
                  </div>
                </div>
              </div>
              <div className="this-lesson-is-to-help-learner1">
                This lesson is to help learners understand basic maths concepts
                such as addition, subtraction, multiplication and diviision
              </div>
              <div className="frame-div142">
                <img
                  className="ellipse-icon"
                  alt=""
                  src="../ellipse-38@2x.png"
                />
                <b className="joy-queen-b">Joy Queen</b>
              </div>
              <div className="frame-div143">
                <div className="frame-div140">
                  <div className="classes-div3">
                    <img
                      className="game-iconsages"
                      alt=""
                      src="../akariconsbook18.svg"
                    />
                    <div className="grade-1-div">14 Lessons</div>
                  </div>
                  <div className="classes-div3">
                    <img
                      className="game-iconsages"
                      alt=""
                      src="../biperson18.svg"
                    />
                    <div className="grade-1-div">Max: 15 Learners</div>
                  </div>
                </div>
                <div className="frame-div140">
                  <div className="grade-div">
                    <img
                      className="game-iconsages"
                      alt=""
                      src="../gameiconsages8.svg"
                    />
                    <div className="grade-1-div">Grade 1</div>
                  </div>
                  <div className="price-div1">
                    <img
                      className="game-iconsages"
                      alt=""
                      src="../akariconsmoney9.svg"
                    />
                    <div className="grade-1-div">{`Ksh 5,000 `}</div>
                  </div>
                </div>
              </div>
              <button
                className="buttondesktopprimary19"
                onClick={onButtonDesktopPrimary9Click}
              >
                <b className="save-and-next30">get more details</b>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-div3">
        <div className="frame-div212">
          <img
            className="outline-24px-chevron-down3"
            alt=""
            src="../antdesigncopyrightoutlined3.svg"
          />
          <b className="classes-that-we-offer">
            2022 ShuleEazy, All Rights Reserved
          </b>
        </div>
      </div>
    </div>
  );
};

export default LiveOnlineClasses;
